export const FLAG_MESSAGE = 'FLAG_MESSAGE';
export const FLAG_MESSAGE_SUCCESS = 'FLAG_MESSAGE_SUCCESS';
export const FLAG_MESSAGE_ERROR = 'FLAG_MESSAGE_ERROR';

export const MANAGE_POPUP = 'MANAGE_POPUP';

export const CLEAN_FEEDBACK_STORE = 'CLEAN_FEEDBACK_STORE';
